// extracted by mini-css-extract-plugin
module.exports = {"root":"login_root__1y_4Q","logo":"login_logo__2MMsi","submit":"login_submit__1wwqr","error":"login_error__3d_dm"};